import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';
import 'primereact/resources/themes/saga-blue/theme.css'; // PrimeReact theme
import 'primereact/resources/primereact.min.css';         // PrimeReact core CSS
import 'primeicons/primeicons.css';                       // PrimeIcons
import './App.css';                                       // Custom styles

// Sidebar component with dropdown filters
const FilterSidebar = ({ filters, setFilters }) => {
  // Example options – adjust as needed
  const industryOptions = [
    { label: 'Technology', value: 'Technology' },
    { label: 'Healthcare', value: 'Healthcare' },
    { label: 'Finance', value: 'Finance' },
  ];

  const stageOptions = [
    { label: 'Seed', value: 'Seed' },
    { label: 'Series A', value: 'Series A' },
    { label: 'Series B', value: 'Series B' },
  ];

  const outwardOptions = [
    { label: 'W1', value: 'W1' },
    { label: 'EC', value: 'EC' },
    { label: 'N1', value: 'N1' },
  ];

  return (
    <Panel header="Filters" className="filter-panel">
      <div className="filter-field">
        <label htmlFor="industry" className="filter-label">Industry</label>
        <Dropdown
          inputId="industry"
          value={filters.industry}
          options={industryOptions}
          onChange={(e) => setFilters({ ...filters, industry: e.value })}
          placeholder="Select an Industry"
          className="filter-dropdown"
        />
      </div>
      <div className="filter-field">
        <label htmlFor="investmentStage" className="filter-label">Investment Stage</label>
        <Dropdown
          inputId="investmentStage"
          value={filters.investmentStage}
          options={stageOptions}
          onChange={(e) => setFilters({ ...filters, investmentStage: e.value })}
          placeholder="Select Investment Stage"
          className="filter-dropdown"
        />
      </div>
      <div className="filter-field">
        <label htmlFor="outward" className="filter-label">Outward Postcode</label>
        <Dropdown
          inputId="outward"
          value={filters.outward}
          options={outwardOptions}
          onChange={(e) => setFilters({ ...filters, outward: e.value })}
          placeholder="Select Outward Postcode"
          className="filter-dropdown"
        />
      </div>
    </Panel>
  );
};

// Map component embedding the pre-generated Folium map via an iframe
const MapComponent = () => {
  return (
    <div className="map-container">
      <iframe
        src="london_startups_map.html"
        title="Startup Map"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
};

// Main App component with updated layout
const App = () => {
  const [filters, setFilters] = useState({
    industry: null,
    investmentStage: null,
    outward: null,
  });

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      {/* Left Sidebar (1/4 width) */}
      <div style={{ width: '25%', overflowY: 'auto', backgroundColor: '#f4f4f4' }}>
        <FilterSidebar filters={filters} setFilters={setFilters} />
      </div>
      {/* Right Main Content (3/4 width) */}
      <div style={{ width: '75%', overflowY: 'auto' }}>
        <MapComponent />
      </div>
    </div>
  );
};

export default App;
